class RrgAnnouncements extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-announcement]')];
    this.countdown = this.querySelector('[data-announcement-countdown]');
    this.index = 0;
    this.updateCountdowns();
    this.updateCountdownVisibility();

    if (this.items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const interval = Number(this.dataset.interval) || 4000;
      this.timer = window.setInterval(() => this.show(this.index + 1), interval);
    }

    this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 60000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
    window.clearInterval(this.countdownTimer);
  }

  show(next) {
    if (!this.items.length) return;
    this.items[this.index]?.classList.remove('is-active');
    this.index = next % this.items.length;
    this.items[this.index]?.classList.add('is-active');
    this.updateCountdownVisibility();
  }

  updateCountdownVisibility() {
    if (!this.countdown) return;
    const visible = this.index === 0;
    this.countdown.classList.toggle('is-hidden', !visible);
    this.countdown.setAttribute('aria-hidden', String(!visible));
  }

  updateCountdowns() {
    this.querySelectorAll('[data-countdown]').forEach((node) => {
      const end = new Date(node.dataset.countdown);
      if (Number.isNaN(end.getTime())) return;
      const days = Math.max(0, Math.floor((end.getTime() - Date.now()) / 86400000));
      node.textContent = String(days);
    });
  }
}

if (!customElements.get('rrg-announcements')) {
  customElements.define('rrg-announcements', RrgAnnouncements);
}

const rrgReveal = () => {
  const elements = [...document.querySelectorAll('[data-rrg-reveal]:not(.rrg-reveal-ready)')];
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach((element) => element.classList.add('rrg-is-visible', 'rrg-reveal-ready'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rrg-is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
  );

  elements.forEach((element) => {
    element.classList.add('rrg-reveal-ready');
    observer.observe(element);
  });
};

document.addEventListener('DOMContentLoaded', rrgReveal);
document.addEventListener('shopify:section:load', rrgReveal);

document.addEventListener('click', (event) => {
  const closeDrawer = event.target.closest('[data-rrg-close-drawer]');
  if (closeDrawer) {
    closeDrawer.closest('details')?.removeAttribute('open');
    return;
  }

  const wishlist = event.target.closest('[data-rrg-wishlist]');
  if (!wishlist) return;
  const productId = wishlist.dataset.productId || 'header';
  const key = `rrg:wishlist:${productId}`;
  const active = localStorage.getItem(key) !== 'true';
  localStorage.setItem(key, String(active));
  wishlist.setAttribute('aria-pressed', String(active));
  wishlist.classList.toggle('is-active', active);
});
